import React from "react";
import Topbar from "../../components/topbar/Topbar";
import AdminTable from "../../components/adminTable/AdminTable";
import "./adminAccess.css";

export default function AdminAccess() {
  return (
    <div className="mainPageContent">
      <Topbar title="ADMIN CONTROLS" showAdminAccess={false} />
      <AdminTable />
    </div>
  );
}
